import { absorbSearch } from '../utils/packageIdentity';

export function setupQuery() {
  window.query = absorbSearch(location.search, localStorage);
}
